import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RequestResetPassword from './pages/RequestResetPassword';
import ResetPasswordConfirm from './pages/ResetPasswordConfirm';
import DashboardPage from './pages/DashboardPage';
import Layout from './components/Layout';
import ParentsPage from './pages/ParentsPage';
import MeetingsPage from './pages/MeetingsPage';
import EventsPage from './pages/EventsPage';
import ProjectsPage from './pages/ProjectsPage';
import SurveysPage from './pages/SurveysPage';
import BibleStudiesPage from './pages/BibleStudiesPage';
import IncidentsPage from './pages/IncidentsPage';
import ContentsPage from './pages/ContentsPage';
import ReportsPage from './pages/ReportsPage';
import UsersPage from './pages/UsersPage';
import SettingsPage from './pages/SettingsPage';
import SchoolClassesPage from './pages/SchoolClassesPage';
import StaffPage from './pages/StaffPage';
import ProfilesPage from './pages/ProfilesPage';
import CheckinPage from './pages/CheckinPage';
import GuestListPage from './pages/GuestListPage';
import MeetingReport from './pages/MeetingReport';
import MyProfilePage from './pages/MyProfilePage';
import { PermissionsProvider } from './context/PermissionsContext';

const PrivateRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('access');
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  return (
    <PermissionsProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<RequestResetPassword />} />
          <Route path="/reset-password/:uid/:token" element={<ResetPasswordConfirm />} />

          <Route path="/checkin/:type/:id" element={<CheckinPage />} />
          <Route path="/report/meeting" element={<MeetingReport />} />

          <Route path="/" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><DashboardPage /></Layout></PrivateRoute>} />
          <Route path="/pais" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><ParentsPage /></Layout></PrivateRoute>} />
          <Route path="/turmas" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><SchoolClassesPage /></Layout></PrivateRoute>} />
          <Route path="/colaboradores" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><StaffPage /></Layout></PrivateRoute>} />
          <Route path="/convidados" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><GuestListPage /></Layout></PrivateRoute>} />
          <Route path="/reunioes" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><MeetingsPage /></Layout></PrivateRoute>} />
          <Route path="/eventos" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><EventsPage /></Layout></PrivateRoute>} />
          <Route path="/projetos" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><ProjectsPage /></Layout></PrivateRoute>} />
          <Route path="/pesquisas" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><SurveysPage /></Layout></PrivateRoute>} />
          <Route path="/estudos-biblicos" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><BibleStudiesPage /></Layout></PrivateRoute>} />
          <Route path="/ocorrencias" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><IncidentsPage /></Layout></PrivateRoute>} />
          <Route path="/conteudos" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><ContentsPage /></Layout></PrivateRoute>} />
          <Route path="/relatorios" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><ReportsPage /></Layout></PrivateRoute>} />
          <Route path="/usuarios" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><UsersPage /></Layout></PrivateRoute>} />
          <Route path="/perfis" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><ProfilesPage /></Layout></PrivateRoute>} />
          <Route path="/configuracoes" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><SettingsPage /></Layout></PrivateRoute>} />

          <Route path="/meu-perfil" element={<PrivateRoute><Layout toggleTheme={toggleTheme} currentTheme={theme}><MyProfilePage /></Layout></PrivateRoute>} />
        </Routes>
      </Router>
    </PermissionsProvider>
  );
}

export default App;
